import React, { useEffect, useRef } from 'react';
import { IMenu } from '../MToolbar.model';

import MToolbarMobileMenuView from './MToolbarMobileMenu.view';

interface Props {
  className?: string;
  menu: IMenu[];
  onExit: () => void;
}

const MToolbarMobileMenu: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const $container = containerRef.current;

    if (!$container) {
      return;
    }

    const checkExit = (event: MouseEvent) => {
      if (!$container.contains(event.target as HTMLDivElement) && event.target !== $container) {
        props.onExit();
      }
    };

    document.addEventListener('click', checkExit);

    return () => {
      document.removeEventListener('click', checkExit);
    };
  }, [containerRef, props.onExit]);

  return (
    <MToolbarMobileMenuView
      className={props.className}
      containerRef={containerRef}
      onExitBtnClick={props.onExit}
      menu={props.menu}
      onMenuItemClick={props.onExit}
    >
      {props.children}
    </MToolbarMobileMenuView>
  );
};

MToolbarMobileMenu.displayName = 'MToolbarMobileMenu';
MToolbarMobileMenu.defaultProps = {};

export default MToolbarMobileMenu;
